<template>
  <div class="main-container">
    <div
      v-show="debugMode"
      class="debug"
      ref="refDebug"
      :style="{ left: leftPx + 'px' }"
    >
      <div>
        <div>
          <input type="text" v-model="signalRUrl" /><br />
          <button @click="connectSignalR">connect signalr</button><br />
          <input type="text" v-model="signalRCmd" placeholder="cmd" /><br />
          <input
            type="text"
            v-model="signalRCmdGroup"
            placeholder="group"
          /><br />
          <input
            type="text"
            v-model="signalRCmdParam"
            placeholder="param"
          /><br />
          <button @click="signalRSend">signalR test</button>
          <button @click="test">signalR leave</button><br />
          SignalRStatus: {{ signalRStatus }}<br />
          <a :href="awsStreamingUrl">awsStreamingUrl</a><br />
          uuid:{{ uuid }}
        </div>
        <div>
          <label>
            <input type="checkbox" v-model="deviceVisiable" />ShowDevice
          </label>
        </div>
        <div>
          <input
            v-model="wdreceiveChannelName"
            placeholder="channel name"
          /><br />
          <input v-model.number="userId" placeholder="uid" />
        </div>
        <hr />
        <div>
          <Agora4
            ref="agora4Fun"
            :receiveChannel="wdreceiveChannelName"
            :spatial="spatial"
            :uid="userId"
            :cntStatus="cntStatus"
            :screenEnable.sync="screenEnable"
            :micEnabled.sync="microphoneEnable"
            :micVolume.sync="micVolume"
            :voiceVolume.sync="voiceVolume"
            :webcamEnable.sync="webcamEnable"
            :wdWatch.sync="wdWatch"
            :speakers="speakers"
            :subscribeMode.sync="subscribeMode"
            :isFirefox="isFirefox"
            :isChrome="isChrome"
            :isResetConnect="isResetConnect"
          />
        </div>
        <hr />
        <div>
          <SpatialAudio
            ref="hifiFun"
            :receiveChannel="wdreceiveChannelName"
            :spatial="spatial"
            :uid="userId"
            :cntStatus="cntStatus"
            :HifiEnable="vivoxEnable"
            :micEnabled.sync="vMicEnable"
            :micVolume.sync="micVolume"
            :voiceVolume.sync="voiceVolume"
            :wdWatch.sync="vWdWatch"
            :speakers="speakers"
            :subscribeMode="subscribeMode"
            :isFirefox="isFirefox"
            :isResetConnect="isResetConnect"
            :rollOff="spatialRollOff"
          />
        </div>
      </div>
      <div style="height: 25px">
        <button @click="leftDebug = !leftDebug">
          {{ leftDebug ? "show" : "hide" }}
        </button>
      </div>
    </div>
    <div id="loading" v-show="loadingVisiable">
      <img :src="loadingImg" />
    </div>
    <div>
      <Toast ref="toastFun" />
    </div>
    <div>
      <div>
        <input
          hidden
          type="file"
          name="file"
          ref="imageInput"
          accept="image/jpeg,image/png,image/jpg"
          @change="fileChange()"
        />
      </div>
    </div>
    <div class="devicePanel" v-show="deviceVisiable">
      <Device
        ref="deviceFun"
        :isShowDevice.sync="deviceVisiable"
        :resetEnabled="resetEnabled"
        @closebox="deviceVisiable = false"
      />
    </div>
    <div>
      <a :href="openUrl" :target="openUrlTarget" ref="linkFun"></a>
    </div>
    <div id="appstream-container"></div>
  </div>
</template>
<script>
import AppStream from "@/assets/Js/appstream_embed.js";
import Agora4 from "./Agora4";
import SpatialAudio from "./SpatialAudio";
import axios from "axios";
import Device from "./Device";
import Keyboard from "./Keyboard";
import Toast from "./Toast";
import eventBus from "../eventBus";
import device from "current-device";

export default {
  components: {
    SpatialAudio,
    Agora4,
    Device,
    Keyboard,
    Toast,
    eventBus,
  },
  name: "AWSAppStream",
  data() {
    return {
      debugMode: false,
      leftDebug: false,
      leftPx: 0,

      userId: 0,
      userName: "",
      wdreceiveChannelName: "",
      regionId: "",
      regionName: "",

      appId: "212.215",
      signalRUrl: process.env.VUE_APP_SIGNALRURL,
      signalRConnection: null,
      signalRReconnectInterval: [0, 1000, 3000],
      signalRCmd: "",
      signalRCmdGroup: "",
      signalRCmdParam: "",
      signalRSendReadyFun: 0,
      signalRSendReadyFunExit: false,
      signalRSendReadyInterval: 2000,
      appstreamEmbed: null,
      uuid: "",
      awsStreamingUrl: "",
      hiddenItems: [],
      playerStop: false,
      gridId: 0, //from url parameter
      autoLogin: true, //yes or no from url parameter
      cookieExpiresDays: 7,
      openUrl: "",
      openUrlTarget: "_blank",
      dataResponse: "",
      saveTextureInfo: {
        userId: "",
        itemId: "",
        tick: "",
        sessionId: "",
        hash: "",
        gridId: "",
      },

      wdWatch: false,
      vWdWatch: false,
      spatial: false,
      vivoxEnable: false,
      agoraEnable: false,
      screenEnable: false,
      webcamEnable: false,
      microphoneEnable: false,
      mutedEnable: false,
      vMicEnable: false,
      vMutedEnable: false,
      cntStatus: {
        dcnted: "DISCONNECTED",
        cnting: "CONNECTING",
        cnted: "CONNECTED",
        dcnting: "DISCONNECTING",
      },
      micVolume: 0.5,
      voiceVolume: 0.8,
      subscribeMode: true, //subscribe remote strem
      speakers: [],
      isResetConnect: false, //need rewrite
      spatialRollOff: 12,

      deviceVisiable: false,
      inputDeviceId: "default",
      inputVideoDeviceId: "",
      loadingImg: require("@/assets/loading.gif"),
      loadingVisiable: false,

      //common
      isChrome: false,
      isFirefox: false,
      isSafari: false,

      isDesktop: false,
      isIOS: false,
      isAndroid: false,
    };
  },
  computed: {
    resetEnabled: function () {
      return this.wdWatch || this.vWdWatch;
    },
    browserType() {
      if (this.isChrome) {
        return "Chrome";
      } else if (this.isFirefox) {
        return "Firefox";
      } else if (this.isSafari) {
        return "Safari";
      } else {
        return "Unknown";
      }
    },
    signalRStatus() {
      if (this.signalRConnection == null) {
        return "DISCONNECTED";
      } else {
        return this.signalRConnection.state;
      }
    },
  },
  watch: {
    leftDebug: function (val) {
      if (val) {
        this.leftPx = -this.$refs.refDebug.offsetWidth + 40;
      } else {
        this.leftPx = 0;
      }
    },
  },
  created() {
    if (typeof awsStreamingUrl != "undefined") {
      this.awsStreamingUrl = awsStreamingUrl;
    }
    if (typeof uuid != "undefined") {
      this.uuid = uuid;
    }
    for (let i = 0; i < 996; i++) {
      this.signalRReconnectInterval.push(5000);
    }
  },
  mounted() {
    // this.connectSignalR();
    this.isDesktop = device.desktop();
    this.isIOS = device.ios();
    this.isAndroid = device.android();
    this.userAgentDetect();

    //set value from url parameter
    this.autoLogin = this.$route.query.autologin == "no" ? false : true;
    console.log("autologin:", this.autoLogin);
    if (typeof gridId != "undefined") {
      this.gridId = isNaN(parseInt(gridId)) ? 0 : parseInt(gridId);
    } else {
      this.gridId = isNaN(parseInt(this.$route.query.grid))
        ? 0
        : parseInt(this.$route.query.grid);
    }
    console.log("grid:", this.gridId);

    let queryName = "";
    if (typeof appId != "undefined") {
      queryName = appId;
    } else {
      queryName = this.$route.query.id;
    }

    if (typeof queryName != "undefined") {
      this.appId = queryName;
    }
    console.log("appId:", this.appId);

    let queryRegionId = this.$route.query.regionid;
    if (typeof queryRegionId != "undefined") {
      this.regionId = queryRegionId;
    }
    console.log(this.regionId);

    let queryRegionName = this.$route.query.regionname;
    if (typeof queryRegionName != "undefined") {
      this.regionName = queryRegionName;
    }
    console.log(this.regionName);

    let querySpatialRollOff = this.$route.query.spatialrolloff;
    if (typeof querySpatialRollOff != "undefined") {
      if (parseInt(querySpatialRollOff)) {
        this.spatialRollOff = parseInt(querySpatialRollOff);
      }
    }
    console.log("spatialRollOff:", this.spatialRollOff);

    //let url = baseUrl;
    if (typeof baseUrl != "undefined") {
      this.baseUrl = baseUrl;
    }
    console.log(this.baseUrl);

    //let cookieid = cookieId;
    if (typeof cookieId != "undefined") {
      this.cookieId = cookieId;
    }
    console.log(this.cookieId);

    // this.connectSignalR();
    this.startAppStream();
  },
  methods: {
    test() {
      console.log("test");
    },
    startAppStream() {
      let userInterfaceConfig = {};
      userInterfaceConfig[AppStream.Embed.Options.HIDDEN_ELEMENTS] =
        this.hiddenItems;
      let appstreamOptions = {
        sessionURL: this.awsStreamingUrl,
        userInterfaceConfig: userInterfaceConfig,
      };
      this.appstreamEmbed = new AppStream.Embed(
        "appstream-container",
        appstreamOptions
      );
      this.appstreamEmbed.addEventListener(
        AppStream.Embed.Events.SESSION_STATE_CHANGE,
        this.updateSessionStateCallback
      );
      this.appstreamEmbed.addEventListener(
        AppStream.Embed.Events.SESSION_INTERFACE_STATE_CHANGE,
        this.updateUserInterfaceStateCallback
      );
      this.appstreamEmbed.addEventListener(
        AppStream.Embed.Events.SESSION_ERROR,
        this.errorCallback
      );
    },
    updateSessionStateCallback(event) {
      console.log("updateSessionStateCallback", event);
    },
    updateUserInterfaceStateCallback(event) {
      console.log("updateUserInterfaceStateCallback", event);
    },
    errorCallback(event) {
      console.log("errorCallback", event);
    },

    connectSignalR() {
      this.signalRConnection = new signalR.HubConnectionBuilder()
        .withUrl(this.signalRUrl)
        .configureLogging(signalR.LogLevel.Information)
        .withAutomaticReconnect(this.signalRReconnectInterval)
        .build();
      // this.signalRConnection.keepAliveIntervalInMilliseconds = 1000 * 10;
      this.signalRConnection.serverTimeoutInMilliseconds = 1000 * 60;

      this.signalRConnection.on("ServerLog", function (msg) {
        console.log("ServerLog: ", msg);
      });
      this.signalRConnection.on("Send", function (msg) {
        console.log("Send: ", msg);
      });
      this.signalRConnection.on("SendToOthersInGroup", (groupName, msg) => {
        console.log(
          "SendToOthersInGroup groupName: " + groupName + ", msg: " + msg
        );
        console.log("SendToOthersInGroup: ", typeof msg);
        let dataObj = JSON.parse(msg);
        console.log("dataObj:", dataObj);
        let sinewave = dataObj.sinewave;
        if (this.playerStop) {
          console.log("playerStop is true return furioos message");
          return;
        }
        switch (sinewave) {
          case "login ready":
            this.signalRSendReadyFunExit = true;
            let browserLanguage = this.getCookie("lang");
            console.log(browserLanguage);
            if (browserLanguage == "") {
              browserLanguage = navigator.language.substring(0, 2);
            }
            console.log("browserLanguage: ", browserLanguage);

            if (this.autoLogin) {
              let cookieId = this.getCookie("cookieid");
              if (typeof this.cookieId != "undefined" && this.cookieId != "") {
                cookieId = this.cookieId;
              }
              if (cookieId.toLowerCase() == "null" || cookieId == "undefined") {
                cookieId = "";
              }
              console.log("autologin true, send cookieid");

              this.signalRSendToOthersInGroup({
                sinewave: "login resume",
                cookieid: cookieId,
                grid: this.gridId,
                regionid: this.regionId,
                regionname: this.regionName,
                browserlanguage: browserLanguage,
              });
            } else {
              console.log("autologin false, send cookieid with empty string");
              this.signalRSendToOthersInGroup({
                sinewave: "login resume",
                cookieid: "",
                grid: this.gridId,
                regionid: this.regionId,
                regionname: this.regionName,
                browserlanguage: browserLanguage,
              });
            }
            break;
          case "user auth":
            console.log(
              "switch user auth and set cookie: username:" + dataObj.username
            );
            this.setCookie(
              "username",
              dataObj.username,
              this.cookieExpiresDays
            );
            this.userName = dataObj.username;
            this.setCookie("userid", dataObj.userid, this.cookieExpiresDays);
            this.setCookie(
              "cookieid",
              dataObj.cookieid == null ? "" : dataObj.cookieid,
              this.cookieExpiresDays
            );
            this.userId = dataObj.userid;
            break;
          case "voice zone":
            let enabled = dataObj.enabled;
            this.wdWatch = enabled && this.agoraEnable;
            this.vWdWatch = enabled && this.vivoxEnable;
            this.spatial = dataObj.spatial;
            if (enabled) {
              if (dataObj.channel != this.wdreceiveChannelName) {
                if (dataObj.channel != null) {
                  this.wdreceiveChannelName = dataObj.channel
                    .replace(/_/g, "")
                    .toLowerCase();
                }
              } else {
                if (this.spatial) {
                  this.$refs.hifiFun.updateUserDataTransmit(
                    dataObj.playerPosition,
                    dataObj.playerEuler,
                    this.spatialRollOff
                  );
                }
              }
            }
            break;
          case "voice state":
            console.log("switch voice state");
            if (dataObj.enabled) {
              if (dataObj.service == "Agora") {
                this.agoraEnable = true;
                if (this.vWdWatch) {
                  this.wdWatch = true;
                }
                this.screenEnable = dataObj.screenshare;
                this.webcamEnable = dataObj.webcam;
                this.microphoneEnable = dataObj.microphone;
                this.mutedEnable = dataObj.muted;
              } else {
                this.vivoxEnable = true;
                this.vMicEnable = dataObj.microphone;
                this.vMutedEnable = dataObj.muted;
              }
            } else {
              if (dataObj.service == "Agora") {
                this.agoraEnable = false;
              } else {
                this.vivoxEnable = false;
              }
            }
            break;
          case "mic volume":
            this.micVolume = dataObj.volume;
            break;
          case "voice volume":
            this.voiceVolume = dataObj.volume;
            break;
          case "open url":
            let url = new RegExp(/^http/i).test(dataObj.url)
              ? dataObj.url
              : "http://" + dataObj.url;
            if (this.isSafari) {
              this.openUrl = url;
              this.openUrlTarget = dataObj.new === false ? "_top" : "_blank";
              this.$refs.linkFun.click();
            } else {
              window.open(url, dataObj.new === false ? "_top" : "_blank");
            }
            break;
          case "upload start":
            console.log("upload start");
            let itemId = dataObj.itemid;
            let userId = dataObj.authplayerid;
            let tick = dataObj.tick;
            let hash = dataObj.hash;
            let sessionId = dataObj.sessionid;
            let gridId = dataObj.gridid;
            this.saveTexture(userId, itemId, tick, sessionId, hash, gridId);
            var interval = setInterval(function () {
              if (this.dataResponse != "") {
                this.signalRSendToOthersInGroup({
                  sinewave: "upload end",
                  cookieid: "",
                  response: this.dataResponse,
                });
                console.log("Upload success!");
                clearInterval(interval);
                return;
              }
            }, 1000);
            break;
          case "select device":
            console.log("show device");
            this.deviceVisiable = true;
            break;
          case "close client":
            console.log("close client");
            this.playerStop = true;
            this.wdWatch = false;
            this.vWdWatch = false;
            this.playerBlackCount = 0;
            // this.player.stop();
            this.showToast("You have logged in again from somewhere else.");
            break;
          case "language":
            this.setCookie("lang", dataObj.type, this.cookieExpiresDays);
            break;
          case "keyboard":
            if (!this.isDesktop) {
              this.$refs.inputFun.setKeyboardFocus(dataObj.value);
            }
            break;
          case "logout":
            console.log("logout client");
            this.playerStop = true;
            this.wdWatch = false;
            this.vWdWatch = false;
            this.playerBlackCount = 0;
            // this.player.stop();
            this.setCookie("cookieid", "", this.cookieExpiresDays);
            break;
          default:
            console.log("no command");
            break;
        }
      });
      this.signalRConnection.on("SendToConnection", function (id, msg) {
        console.log("SendToConnection id: " + id + ", msg: " + msg);
      });
      this.signalRConnection.on("SendToGroup", function (key, msg) {
        console.log("SendToGroup key: " + key + ", msg: " + msg);
      });
      this.signalRConnection.onreconnected((connectionId) => {
        // this.signalRStatus = "CONNECTED";
        this.signalRConnection.invoke("JoinGroup", this.uuid);
        this.signalRSendReadyFun = setInterval(() => {
          if (!this.signalRSendReadyFunExit) {
            this.signalRSendReady();
          } else {
            clearInterval(this.signalRSendReadyFun);
          }
        }, this.signalRSendReadyInterval);
        console.log("reconnected join group");
      });
      this.signalRConnection.onreconnecting((error) => {
        // this.signalRStatus = "RECONNECTING";
        this.this.signalRSendReadyFunExit = true;
        console.log("onreconnecting: ", error);
      });
      this.signalRConnection.onclose((error) => {
        // this.signalRStatus = "DISCONNECTED";
        this.this.signalRSendReadyFunExit = true;
        console.log("onclose: ", error);
      });
      this.signalRConnection
        .start({ transport: "longPolling" })
        .then(() => {
          console.log("success");
          try {
            // this.signalRStatus = "CONNECTED";
            this.signalRConnection.invoke("JoinGroup", this.uuid);
            console.log("join group");

            this.signalRSendReadyFun = setInterval(() => {
              if (!this.signalRSendReadyFunExit) {
                this.signalRSendReady();
              } else {
                clearInterval(this.signalRSendReadyFun);
              }
            }, this.signalRSendReadyInterval);
            console.log("worldstream ready");
          } catch (err) {
            console.error(err);
          }
        })
        .catch(function (err) {
          return console.error(err.toString());
        });
    },
    signalRSendReady() {
      this.signalRSendToOthersInGroup({
        sinewave: "worldstream ready",
        regionid: this.regionId,
        regionname: this.regionName,
      });
    },

    signalRSend() {
      try {
        this.signalRConnection
          .invoke(this.signalRCmd, this.signalRCmdGroup, this.signalRCmdParam)
          .catch(function (err) {
            return console.error(err.toString());
          });
        console.log(this.signalRCmd);
        console.log(this.signalRCmdGroup);
        console.log(this.signalRCmdParam);
      } catch (err) {
        console.error(err);
      }
    },
    signalRSendToOthersInGroup(msgObj) {
      this.signalRConnection.invoke(
        "SendToOthersInGroup",
        this.uuid,
        JSON.stringify(msgObj)
      );
    },

    saveTexture: function (userId, itemId, tick, sessionId, hash, gridId) {
      this.$refs.imageInput.dispatchEvent(new MouseEvent("click"));
      this.saveTextureInfo.userId = userId;
      this.saveTextureInfo.itemId = itemId;
      this.saveTextureInfo.tick = tick;
      this.saveTextureInfo.sessionId = sessionId;
      this.saveTextureInfo.hash = hash;
      this.saveTextureInfo.gridId = gridId;
    },
    showToast(text, time = 0, btnFun = null, ...btnFunParams) {
      this.$refs.toastFun.showToast(text, time, btnFun, ...btnFunParams);
    },
    closeToast: function () {
      this.$refs.toastFun.closeToast();
    },
    toastRun: async function (cmd) {
      this.$refs.toastFun.closeToast();
      switch (cmd) {
        case "reconnectByMicOpenError":
          await this.$refs.agora4Fun.leaveChannel();
          await this.$refs.agora4Fun.joinChannel();
          break;
        case "setPlayerActive":
          console.log("toastRun setPlayerActive");
          this.setUserActiveTimes = 0;
          // this.player.setUserActive();
          break;
        default:
          console.log("toastRun:", cmd);
          break;
      }
    },

    userAgentDetect: function () {
      let userAgent = navigator.userAgent;

      if (userAgent.indexOf("Safari") >= 0 && userAgent.indexOf("Chrome") < 0) {
        this.showToast(
          "Safari is not recommended for World Streaming. For the best experience, please use Google Chrome, Mozilla Firefox or Microsoft Edge."
        );
      }
    },
    sendRemoteAudioData: function (data) {
      this.signalRSendToOthersInGroup({
        sinewave: "audio volume",
        data: data,
      });
    },

    fileChange: function () {
      var formdata = new FormData();
      if (this.$refs.imageInput.files.length == 0) {
        this.$refs.toastFun.showToast("File must not be empty!");
        return;
      }
      let sizeApp = this.$refs.imageInput.files[0].size;
      if (sizeApp / (1024 * 1024) > 5) {
        this.$refs.toastFun.showToast("File size must not be less than 5M!");
        return;
      }
      let AllUpExt = ".jpg|.png|.jpeg|";
      let extName = this.$refs.imageInput.files[0].name
        .substring(this.$refs.imageInput.files[0].name.lastIndexOf("."))
        .toLowerCase();
      if (AllUpExt.indexOf(extName + "|") == "-1") {
        this.$refs.toastFun.showToast("File type error!");
        return;
      }
      let filename = (extName = this.$refs.imageInput.files[0].name);
      filename = filename.split(".")[0];
      formdata.append("fileuploaded", this.$refs.imageInput.files[0]);
      formdata.append("authplayerid", this.saveTextureInfo.userId);
      formdata.append("tick", this.saveTextureInfo.tick);
      formdata.append("sessionid", this.saveTextureInfo.sessionId);
      formdata.append("hash", this.saveTextureInfo.hash);
      formdata.append("itemid", this.saveTextureInfo.itemId);
      formdata.append("name", filename);
      formdata.append("gridid", this.saveTextureInfo.gridId);
      if (this.baseUrl != "") {
        axios
          .post(this.baseUrl + "/worldapi/gameitem/save_texture", formdata)
          .then((response) => {
            console.log(response);
            this.dataResponse = response.data;
          });
      }
    },
    resetConnect: function () {
      if (!this.wdWatch && !this.vWdWatch) {
        return;
      }
      eventBus.$emit("reseting", true);
      this.isResetConnect = true;
      setTimeout(() => {
        this.isResetConnect = false;
        eventBus.$emit("reseting", false);
      }, this.resetTime);
    },
    report: function () {
      eventBus.$emit("reporting", true);
      var formdata = new FormData();
      let consoleData = this.useLocalStorage
        ? localStorage.getItem("furioos")
        : this.logArr.join(";\n");
      console.log("console length:", consoleData.length);
      formdata.append("console", consoleData);
      formdata.append("userid", this.userId);
      formdata.append("username", this.userName);
      formdata.append("gridid", this.gridId);
      formdata.append("gridname", this.gridName);
      formdata.append("regionid", this.regionId);
      formdata.append("regionname", this.regionName);
      formdata.append("appid", this.appId);
      formdata.append("url", window.location.href);
      formdata.append("room", this.wdreceiveChannelName);
      formdata.append("agnet", navigator.userAgent);
      formdata.append("isdesktop", this.isDesktop);
      if (this.isChrome) {
        formdata.append("browser", "chrome");
      } else if (this.isSafari) {
        formdata.append("browser", "safari");
      } else {
        formdata.append("browser", "firefox");
      }

      let that = this;
      that.toastText = "report submit";
      that.showToast("report submit");
      axios
        .post(this.baseUrl + "/worldstream/report", formdata)
        .then((response) => {
          console.log(response);
          that.showToast("report success");
          setTimeout(() => {
            that.closeToast();
          }, 2000);
          eventBus.$emit("reporting", false);
        })
        .catch((e) => {
          that.toastText = e.message;
          setTimeout(() => {
            that.closeToast();
          }, 2000);
          eventBus.$emit("reporting", false);
        });
    },
  },
};
</script>
<style scoped>
#appstream-container {
  width: 100%;
  height: 100%;
}
</style>


// WEBPACK FOOTER //
// src/components/AWSAppStream.vue